import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Filter9Icon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_9"}/>
}
